export const BAR_PRODUCT_FEATURE_FLAG_HIDDEN = false
export const SHOW_MARKETING_PAGES = false
